import React from "react";
import { Typography, Paragraph } from "antd";
import "./ProjectItem.css"
const { Title } = Typography;

const ProjectItem = ({ project, onClick }) => {
  return (
    <div className="project-item" onClick={() => onClick(project)}>
      <div className="project-preview">
        <img src={project.images[0]} alt={project.title} className="preview-image" />
      </div>
      <div className="project-info">
        <Title level={5} className = "project-preview-title">{project.title}</Title>
        <p className = "project-preview-blurb">{project.blurb}</p>
        <div className="project-author">
          <img src={project.authorAvatar} alt={project.author} className="author-avatar" />
          <span>{project.author}</span>
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;
